// All dates/times defined in content config are
// using LocalDateString/LocalTimeString representation:
// - LocalDateString (yyyy-mm-dd)
// - LocalTimeString (mm:hh)

export const toDate = obj => new Date(obj)
export const timeToDate = time =>
  toDate(
    '1970-01-01T' +
      time
        .toString()
        .split(/:/g)
        .map(s => s.padStart(2, '0'))
        .join(':')
  )
export const currentDate = () => new Date()
export const addTime = (time, millisecondsDuration) =>
  toLocalTimeString(timeToDate(time) - -millisecondsDuration)

export const byDatesAsc = (a, b) => toDate(a) - toDate(b)
export const byTimesAsc = (a, b) => timeToDate(a) - timeToDate(b)

const WEEKDAY_NAMES = {
  'CZ-cz': [
    'neděle',
    'pondělí',
    'úterý',
    'středa',
    'čtvrtek',
    'pátek',
    'sobota',
  ],
  'SK-sk': [
    'nedeľa',
    'pondelok',
    'utorok',
    'streda',
    'štvrtok',
    'piatok',
    'sobota',
  ],
  'EN-en': [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
}
export const getDayName = (date, preferredLocales) => {
  // Overrides for most common languages in case the user doesn't have them installed
  const preferredLocale = Array.isArray(preferredLocales)
    ? preferredLocales[0]
    : preferredLocales
  const overrideWeekdays = WEEKDAY_NAMES[preferredLocale]
  return overrideWeekdays
    ? overrideWeekdays[date.getDay()]
    : date.toLocaleString(preferredLocales, { weekday: 'long' })
}

// date to local string representation (2018-01-15)
export const toLocalDateString = date => {
  date = toDate(date)
  const y = date.getFullYear()
  const m = (date.getMonth() + 1).toString().padStart(2, '0')
  const d = date
    .getDate()
    .toString()
    .padStart(2, '0')
  return [y, m, d].join('-')
}

// date to local time representation (10:24)
export const toLocalTimeString = date => {
  date = toDate(date)
  const h = date
    .getHours()
    .toString()
    .padStart(2, '0')
  const m = date
    .getMinutes()
    .toString()
    .padStart(2, '0')
  return h + ':' + m
}

// local date string (2018-01-15) to local date
export const toLocalDate = localDateString => {
  const [y, m1, d] = localDateString.split('-').map(s => parseInt(s, 10))
  return new Date(y, m1 - 1, d)
}

// local date string (2018-01-15) to formatted local date
export const formatLocalDateString = (localDateString, preferredLocales) => {
  return toLocalDate(localDateString).toLocaleDateString(preferredLocales)
}



// WEBPACK FOOTER //
// ./src/app/timeUtils.js